var _defs, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOhmWeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 32,
    fill: "none",
    viewBox: "0 0 62 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    x2: 16,
    y2: 32,
    gradientTransform: "translate(29.99 -.053498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444243",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#708B96",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.010288 .053497)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.99,
    cy: 15.947,
    r: 15,
    fill: "#fff",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.239 20.923v-7e-4l-6.2496-3.6266 6.2495 8.6508v1e-4h1e-4v-1e-4l6.2529-8.6508z",
    clipRule: "evenodd",
    fill: "#708b96",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.239 5.9466v-8e-5.00016l6.2487 10.185-6.2487-2.7923-6.2496 2.7923 6.2495-10.185v-.00016zm-1e-4 7.3948-6.2495 2.7906 6.2495 3.6282h1e-4l6.2487-3.6282-6.2487-2.7906z",
    clipRule: "evenodd",
    fill: "#424242",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 16c0-8.8366 7.1634-16 16-16 8.8366 0 16 7.1634 16 16 0 8.8366-7.1634 16-16 16-8.8366 0-16-7.1634-16-16z",
    fill: "#708B96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.536 23.04v.032h5.504v-1.984h-2.718c1.6354-1.239 2.686-3.165 2.686-5.328 0-3.7379-3.1376-6.768-7.008-6.768s-7.008 3.0301-7.008 6.768c0 2.163 1.0507 4.089 2.686 5.328h-2.718v1.984h5.504v-2.6666c-2.0054-.6312-3.456-2.4653-3.456-4.6294 0-2.6863 2.235-4.864 4.992-4.864s4.992 2.1777 4.992 4.864c0 2.1641-1.4505 3.9982-3.456 4.6294v2.6346z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhmWeth);
export default __webpack_public_path__ + "static/media/OHM-WETH.ee5dc531.svg";
export { ForwardRef as ReactComponent };